document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".nav-link");
  const contents = document.querySelectorAll(".tab-content");

  function deactivateAllTabs() {
    tabs.forEach((tab) => tab.classList.remove("active"));
    contents.forEach((content) => (content.style.display = "none"));
  }

  function activateTab(tab, isUserAction = false) {
    const tabId = tab.getAttribute("data-tab");
    const content = document.getElementById(tabId);

    tab.classList.add("active");
    content.style.display = "block";

    if (isUserAction) {
      tab.scrollIntoView({ behavior: "smooth",block: "center", inline: "start" });
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      deactivateAllTabs();
      activateTab(this, true); 
    });
  });

  if (tabs.length > 0) {
    deactivateAllTabs();
    activateTab(tabs[0]);
  }
});
